import * as o from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/Lifebuoy.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: f }));
e.displayName = "LifebuoyIcon";
const c = e;
export {
  c as Lifebuoy,
  e as LifebuoyIcon
};
